// Read-only public canvas island entry (§2.9). Imports ONLY the core renderer +
// transform + pan/zoom — NO editing modules — so this bundle stays tiny
// (<15KB gz). Data is inlined server-side; there are zero API calls. A card tap
// navigates to its post URL.

import { mountIsland, readConfig } from "../shared/mount";
import { CanvasStore } from "./core/state";
import { Renderer } from "./core/render";
import type { CanvasCtx, Card, PublicConfig, ToolMode } from "./core/types";
import { PointerRouter } from "./interaction/pointer-router";
import { ZoomControls } from "./interaction/zoom-controls";
import { PanMode } from "./interaction/mode-pan";

mountIsland("canvas-root", (root) => {
  const config = readConfig<PublicConfig>("canvas-config");
  const data = config.data ?? { cards: [], edges: [], zones: [] };
  const store = new CanvasStore(data, 0);
  store.mode = "pan";

  const renderer = new Renderer(root, store, { readonly: true });

  const base = config.postUrlBase ?? "/";
  const ctx: CanvasCtx = {
    store,
    renderer,
    root,
    readonly: true,
    history: null,
    sync: null,
    getMode: (): ToolMode => "pan",
    setMode: () => {},
    requestRender: () => renderer.renderAll(),
    saveView: () => {},
    onCardActivate: (card: Card) => {
      const dest = card.slug ? base + card.slug : base + card.docId;
      console.log("navigate:", dest);
      location.href = dest;
    },
  };

  new PointerRouter(ctx, { pan: new PanMode(ctx) }).attach();
  new ZoomControls(ctx);

  renderer.renderAll();
  renderer.applyView();

  (window as unknown as { __canvas?: unknown }).__canvas = { store, renderer, ctx };
  console.log("island loaded: canvas-public", { cards: store.cards.size, edges: store.edges.size, zones: store.zones.size });
});
